import ComingSoon from './ComingSoon';
import { Building } from 'lucide-react';

const Organizations = () => {
  return (
    <div className="container mx-auto py-8 px-4">
      <header className="mb-8">
        <h1 className="text-3xl font-bold flex items-center gap-2">
          <Building className="h-8 w-8" />
          Organizations
        </h1>
        <p className="text-gray-500 mt-2">
          View and manage all organizations in the system
        </p>
      </header>
      <ComingSoon
        title="Organizations"
        description="Organization management with filtering, sorting, and detailed views will be available soon."
        icon={<Building className="h-8 w-8 text-blue-600" />}
      />
    </div>
  );
};

export default Organizations;
